import React from "react";
import { titleToSlug, uniqueId } from "../../../utils/generalLiveCenter";
// Adjust path if needed

const Tabs = ({
  data = [],
  type = "",
  countShow = false,
  sport = "football",
  name,
  id,
  clas = "",
  state = "team",
  dictionary,
  currentTab,
  websiteBaseUrl,
  dataPath,
}) => {

  const getActiveClass = (tabName) => {
    if (!currentTab) return "";
    if (type === "newsTab") {
      return currentTab.toLowerCase() === tabName?.toLowerCase()?.replace('-', ' ') ? "active" : "";
    }

    const tabKey = tabName.replaceAll("_", "-").toLowerCase();
    return currentTab.toLowerCase() === tabKey ||
      (currentTab === "/" && tabName === "My Matches")
      ? "active"
      : "";
  };

  return (
    <nav className={`main_tab ${clas}`}>
      <ul className="nav nav_tabs">
        {data?.map((val, ind) => {
          const tabLabel = countShow ? val?.tabName : val?.replaceAll("_", " ");
          const isActive = getActiveClass(tabLabel);
          const getFormattedLink = (val) => {
            const base = websiteBaseUrl || "";
            const path = dataPath || sport;
            const slug = val.replaceAll("_", "-");

            return `${base}/${path}/${sport === 'tennis' && state === 'team' ? 'player' : state}/${sport === 'tennis' ? name?.split("-").at(-1)?.trim() : titleToSlug(name)}/${id}/${slug}`;
          };

          const link = countShow ? val?.link : getFormattedLink(val);

          const label = countShow
            ? val?.tabName
            : (
              dictionary?.[val?.replaceAll("_", "")] ||
              val.charAt(0).toUpperCase() + val.slice(1)
            ).replaceAll("_", " ");

          return (
            <li key={uniqueId(ind)}>
              <a className={isActive} href={link}>
                {label}
                {/* Optional count display */}
                {/* {countShow && (
                  <span
                    className="count"
                    style={{ borderRadius: val?.count > 1 ? "18px" : undefined }}
                  >
                    {val?.count || 0}
                  </span>
                )} */}
              </a>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default Tabs;
